import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { User } from '../user';
import { StockLocationRole, StockLocationRoleAssignment } from './stockLocationRoleAssignment';

export class StockLocationRoleAssignmentInput
  extends StockLocationRoleAssignment
  implements EntityInput<StockLocationRoleAssignment>
{
  forCreate(): CreateStockLocationRoleAssignmentInput {
    return CreateStockLocationRoleAssignmentInput.from(this, CreateStockLocationRoleAssignmentInput);
  }

  forUpdate(): UpdateStockLocationRoleAssignmentInput {
    return UpdateStockLocationRoleAssignmentInput.from(this, UpdateStockLocationRoleAssignmentInput);
  }

  forDelete(): DeleteStockLocationRoleAssignmentInput {
    return DeleteStockLocationRoleAssignmentInput.from(this, DeleteStockLocationRoleAssignmentInput);
  }

  validate() {
    if (!this.stockLocationId) return false;
    if (!this.role) return false;
    if (!this.userId) return false;
    if (!this.email) return false;

    return true;
  }

  withRole(role: StockLocationRole) {
    this.role = role;
    return cloneDeep(this);
  }

  withUser(user: User | undefined) {
    if (user) {
      this.userId = user.id;
      this.email = user.email;
    } else {
      this.userId = '';
      this.email = '';
    }

    return cloneDeep(this);
  }
}

export class CreateStockLocationRoleAssignmentInput extends forCreate(StockLocationRoleAssignment) {}

export class UpdateStockLocationRoleAssignmentInput extends forUpdate(StockLocationRoleAssignment) {}

export class DeleteStockLocationRoleAssignmentInput extends forDelete(StockLocationRoleAssignment) {}
